import React from 'react';
import { Main } from 'fragments';
import { AbaSchedulingFragment } from './fragments';

export const AbaScheduling = () => {

    return (
        <Main>
            <AbaSchedulingFragment />
        </Main>
    );
};
